import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { LinearProgress } from '@material-ui/core';

const StrengthMeter = styled.div`
	margin: 20px 0;

	.sm__heading {
		margin: 20px 0 10px 0;
		font-size: 14px;
		font-weight: 400;
	}

	.sm__progress {
		position: relative;
	}

	.sm__bar {
		width: 100%;
		height: 50px;
		border-radius: 5px;
		background-color: ${(props) => props.theme.palette.background.secondary};

		&.is-weak {
			.MuiLinearProgress-barColorPrimary {
				background-color: ${(props) => props.theme.palette.background.error};
			}
		}

		&.is-medium {
			.MuiLinearProgress-barColorPrimary {
				background-color: ${(props) => props.theme.palette.background.error};
			}
		}

		&.is-strong {
			.MuiLinearProgress-barColorPrimary {
				background-color: ${(props) => props.theme.palette.background.warning};
			}
		}

		&.is-max {
			.MuiLinearProgress-barColorPrimary {
				background-color: ${(props) => props.theme.palette.background.success};
			}
		}
	}

	.sm__status {
		position: absolute;
		top: 50%;
		left: 20px;
		transform: translateY(-50%);
		text-shadow: 0 0 10px ${(props) => props.theme.palette.primary.dark};
		font-weight: bold;
	}
`;

const PasswordStrengthMeter = ({ StringtoCheck }) => {
	const initialLoadingState = {
		progress: 0,
		text: '',
		color: '',
	};

	const [passwordLength, setPasswordLength] = useState({
		value: false,
		progress: 0,
	});
	const [containsNumbers, setContainsNumbers] = useState({
		value: false,
		progress: 0,
	});
	const [isUpperCase, setIsUpperCase] = useState({
		value: false,
		progress: 0,
	});
	const [containsSymbols, setContainSymbols] = useState({
		value: false,
		progress: 0,
	});
	const [loadingbar, setLoadingbar] = useState(initialLoadingState);

	useEffect(() => {
		if (!StringtoCheck) {
			setLoadingbar(initialLoadingState);
			return;
		}
		handleChange(StringtoCheck);
		handleLoadingBar();
	}, [StringtoCheck]); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		handleLoadingBar();
	}, [passwordLength]); // eslint-disable-line react-hooks/exhaustive-deps

	const handleChange = (stringCheck) => {
		const targetValue = stringCheck.replace(/\s/g, '');
		checkForNumbers(targetValue);
		checkForUpperCase(targetValue);
		checkForSymbols(targetValue);
		setPasswordLength({
			value: targetValue.length > 7 ?? true,
			progress: targetValue.length > 7 ? 25 : 0,
		});
	};

	const checkForNumbers = (string) => {
		const matches = string.match(/\d+/g);
		setContainsNumbers({
			value: matches !== null ?? true,
			progress: matches !== null ? 25 : 0,
		});
	};

	const checkForUpperCase = (string) => {
		const matches = string.match(/[A-Z]/);
		setIsUpperCase({
			value: matches !== null ?? true,
			progress: matches !== null ? 25 : 0,
		});
	};

	const checkForSymbols = (string) => {
		const symbols = new RegExp(/[^A-Z a-z0-9]/);
		setContainSymbols({
			value: symbols.test(string) ?? true,
			progress: symbols.test(string) ? 25 : 0,
		});
	};

	const handleLoadingBar = () => {
		const calculate =
			passwordLength.progress +
			containsNumbers.progress +
			isUpperCase.progress +
			containsSymbols.progress;

		switch (calculate) {
			case calculate < 25:
				setLoadingbar({ progress: calculate, text: 'Schwach', color: 'is-weak' });
				break;
			case 25:
				setLoadingbar({ progress: calculate, text: 'Schwach', color: 'is-weak' });
				break;

			case 50:
				setLoadingbar({
					progress: calculate,
					text: 'Mittel',
					color: 'is-medium',
				});
				break;

			case 75:
				setLoadingbar({ progress: calculate, text: 'Stark', color: 'is-strong' });
				break;

			case 100:
				setLoadingbar({
					progress: calculate,
					text: 'Perfekt',
					color: 'is-max',
				});
				break;
			default:
				setLoadingbar({ progress: calculate, text: 'Schwach', color: 'is-weak' });
				break;
		}
	};

	return (
		<StrengthMeter>
			<h6 className="sm__heading">Passwortstärke</h6>
			<div className="sm__progress">
				<LinearProgress
					className={`sm__bar ${loadingbar.color}`}
					variant="determinate"
					value={loadingbar.progress}
				/>
				<span className="sm__status">{loadingbar.text}</span>
			</div>
		</StrengthMeter>
	);
};

export default PasswordStrengthMeter;
